var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelcircle = function SvgCancelcircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "12 12 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 31a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z",
    fill: "#000",
    style: {
      fill: "currentColor"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.672 18.672 5.656 5.656M18.672 24.328l5.656-5.656",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgCancelcircle;